
import { useLazyQuery ,gql} from "@apollo/client";
import {useDispatch} from "react-redux"
import {GET_PRODUCT_QUESTION_LIST} from "../../constants/product-questions/getProductQuestionConst"

const GET_PRODUCT_QUESTIONS=gql`
query GetProductQuestions($page: Int, $limit: Int, $orderId: Int, $token: String, $productId: Int, $slug: String, $sessionId: String) {
  getProductQuestions(page: $page, limit: $limit, orderId: $orderId, token: $token, productId: $productId, slug: $slug, sessionId: $sessionId) {
    success
    message
    data {
      totalAnsweredQuestions
      questions {
        draftId
        id
        type
        question_text
        options {
          id
          option_text
          isCorrect
        }
      }
      isIdentityRequired
      totalCount
      totalPage
    }
  }
}
`;

var page;
export const GetProductQuestionsAction=()=>{
    const dispatch=useDispatch()
    const [getProductQuestionResponseFunction,
    getProductQuestionResponseData]=useLazyQuery(GET_PRODUCT_QUESTIONS,{
        fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    onCompleted:({getProductQuestions:responseData})=>{
      console.log("252525",responseData)
     dispatch({
      type:GET_PRODUCT_QUESTION_LIST,
      payload:responseData?.data,
      page
     })
        if (responseData.success) {
            // toast.success(responseData?.message)
          } else {
            // toast.error(responseData?.message)
          }
    }
    })

    const getProductQuestionQueryData=getProductQuestionResponseData;

    const initGetProductQuestionData=(data)=>{
        getProductQuestionResponseFunction({
            variables:data
        })
    };

    return {getProductQuestionQueryData,initGetProductQuestionData}
}